import React, { useState, useRef } from 'react';
import { Button, Spinner, TextInput } from 'flowbite-react';
import showToast from '../../../../components/CustomToast/toastHelper';
import client from '../../../../api/client';
import { useNavigate } from 'react-router-dom';
import logo from '../../../../assets/Ideos.png'

interface VerificationProps {
    close: () => void,
    batchId: Number,
    onSuccessfulVerification: () => void,
}
const PayoutVerificationModal = ({ close, batchId, onSuccessfulVerification }: VerificationProps) => {
    const navigate = useNavigate()

    const [otp, setOtp] = useState<string[]>(['', '', '', '', '', '']);
    const [loading, setLoading] = useState<boolean>(false)
    const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const { value } = e.target;
        if (value.length > 1 || isNaN(Number(value))) return; // Only accept one digit and numbers

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Focus the next input if a value is entered
        if (value && index < 5) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            // Move to the previous input if current is empty and backspace is pressed
            inputRefs.current[index - 1]?.focus();
        }
    };

    const verifyPayout = async (batchId: Number) => {
        setLoading(true)
        const payload = {
            batchId: batchId,
            otp: otp.join('')
        }
        try {
            const response = await client.post('/subsidiary/payout/verify', payload);
            const message = response?.data?.message;
            console.log(response);

            showToast(message, "success");
            close();
            onSuccessfulVerification()
            navigate('/transfers/transfer-details')
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
        finally {
            setLoading(false)
        }
    }

    const resendOtp = async (batchId: Number) => {
        try {
            const response = await client.get(`/subsidiary/payout/resend/otp/${batchId}`);
            const message = response?.data?.message;
            showToast(message, "success");
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    }

    return (
        <div>
            <p className='text-lg font-semibold'>Verify Payout</p>
            <p className='text-sm'>Please enter the one-time password sent to you, to verify this transaction</p>
            <div className='grid grid-cols-6 gap-3 my-4'>
                {otp.map((digit, index) => (
                    <TextInput
                        key={index}
                        type="text"
                        maxLength={1} // Ensure only one character is allowed
                        value={digit}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        ref={(el) => (inputRefs.current[index] = el)} // Set refs for each input
                        className="text-center"
                    />
                ))}
            </div>
            <div className='my-4'>
                <Button onClick={() => verifyPayout(batchId)} className='bg-custom-button-green text-black hover:text-white w-full'>{loading ? <Spinner size='sm' /> : 'Verify Payout'}</Button>
            </div>
            <div>
                <p className='text-center text-sm'>Did not receieve otp? <span className='text-green-800 hover:cursor-pointer' onClick={() => resendOtp(batchId)}>Resend OTP</span></p>
            </div>
            {loading && (
                <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/70">
                    <img src={logo} alt="Loading..." className="w-16 animate-spin" />
                </div>
            )}
        </div>
    );
};

export default PayoutVerificationModal;
